import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {SelectionModel} from '@angular/cdk/collections';


@Component({
    selector: 'app-link-lot',
    templateUrl: './link-lot.component.html',
    styleUrls: ['./link-lot.component.scss']
})

export class LinkLotComponent implements OnInit {
    displayedColumns: string[] = ['lotNumber', 'price', 'lotSize', 'bed', 'bath', 'car'];
    dataSource = [];
    selection = new SelectionModel<any>(true, []);
    position = new SelectionModel<any>(true, []);
    constructor(
        private dialogRef: MatDialogRef<any>,
        @Inject(MAT_DIALOG_DATA) public data: any) {
    }

    ngOnInit(): void {
        console.log(this.data);
    }

}
